/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap'); // includes jquery, axio

require('./components/layout.js');

window.Vue = require('vue').default;


import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)

import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);





Vue.filter('francs', function (value) {
    if (!value) return '0.—'
    return value.toFixed(2).replace('.00','.—')
})
Vue.filter('francsVat', function (value) {
    if (!value) return '0.—';
    let vat = (value * 0.081);
    return vat.toFixed(2).replace('.00','.—');
})
Vue.filter('francsNetto', function (value) {
    if (!value) return '0.—';
    let vatnet = (value / 1.081);
    return vatnet.toFixed(2).replace('.00','.—');
})



/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('kindergarten-component', require('./components/KindergardenComponent.vue').default);
Vue.component('hotlunch-component', require('./components/HotlunchComponent.vue').default);

Vue.component('prekindergarten-component', require('./components/PrekindergardenComponent.vue').default);
Vue.component('holidaycare-component', require('./components/HolidaycareComponent.vue').default);
Vue.component('schoolbus-component', require('./components/SchoolbusComponent.vue').default);

Vue.component('primarschule-component', require('./components/PrimarschuleComponent.vue').default);
Vue.component('summary-component', require('./components/SummaryComponent.vue').default);
Vue.component('daycare-component', require('./components/DaycareComponent.vue').default);
Vue.component('application-component', require('./components/ApplicationComponent.vue').default);
Vue.component('lunch-component', require('./components/LunchComponent.vue').default);
Vue.component('input-text-component', require('./components/formelements/InputTextComponent.vue').default);
Vue.component('input-date-component', require('./components/formelements/InputDateComponent.vue').default);
Vue.component('input-daterange-component', require('./components/formelements/InputDaterangeComponent.vue').default);
Vue.component('input-radio-component', require('./components/formelements/InputRadioComponent.vue').default);
Vue.component('input-textarea-component', require('./components/formelements/InputTextareaComponent.vue').default);
Vue.component('input-checkbox-component', require('./components/formelements/InputCheckboxComponent.vue').default);

Vue.component('application-component', require('./components/ApplicationComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
